export default "__VITE_PUBLIC_ASSET__4f374d9d__"